export default {
      id: "arrow-filled-up-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#arrow-filled-up",
      toString: function () {
        return this.url;
      }
    }